import { useTheme } from "@mui/material";
import {
  ArrowDownSimple,
  Button,
  Download,
  PopOver,
} from "@totalenergiescode/mobility-business-rev-design-system";
import { useState } from "react";

import { StyledPopOverContent } from "./style";
import { DownloadsProps } from "./types";

export const Downloads = ({
  downloadMigrationResults,
  translateFunction,
  data,
}: DownloadsProps) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  return (
    <>
      <Button
        dataTestId='ledgers__card-information-section_pop-over-button'
        variant='secondary'
        colorScheme='primary'
        buttonText={translateFunction("migrationReport.actions.download")}
        isLowercase
        onClick={(e) => setAnchorEl(e.currentTarget)}
        rightIcon={<ArrowDownSimple height={20} width={20} />}
      />
      <PopOver
        onClose={() => setAnchorEl(null)}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        dataTestId='ledgers__card-information-section_pop-over'
        disableScrollLock={true}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <StyledPopOverContent>
          <Button
            variant='tertiary'
            isLowercase
            buttonText={translateFunction(
              "migrationReport.actions.downloadSuccesses",
            )}
            onClick={(e) => {
              setAnchorEl(e.currentTarget);
              downloadMigrationResults(data?.successfulMigrations);
            }}
            size='s'
            disabled={!data?.successfulMigrations.length}
            leftIcon={
              <Download
                width={23}
                height={23}
                color={theme.palette.common.white}
              />
            }
          />
          <Button
            variant='tertiary'
            isLowercase
            buttonText={translateFunction(
              "migrationReport.actions.downloadFailures",
            )}
            onClick={(e) => {
              downloadMigrationResults(data?.failedMigrations);
              setAnchorEl(e.currentTarget);
            }}
            size='s'
            disabled={!data?.failedMigrations.length}
            leftIcon={
              <Download
                width={23}
                height={23}
                color={theme.palette.common.white}
              />
            }
          />
        </StyledPopOverContent>
      </PopOver>
    </>
  );
};
